// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Banner,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { ModalConfirm } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { lightGrey } from '@fortress-technology-solutions/fortress-component-library/design';
import confirmMessages from '../../../../components/ConfirmDialogModal/messages';
import messages from '../messages';

type CompleteCertificationsModalProps = {
  effectiveDate: string,
  hasMissingRequiredData: boolean,
  isSubmitting?: boolean,
  onCancel: () => void,
  onConfirm: () => void,
  open: boolean,
};

const CompleteCertificationsModal = ({
  effectiveDate,
  hasMissingRequiredData,
  isSubmitting = false,
  onCancel,
  onConfirm,
  open,
}: CompleteCertificationsModalProps) => {
  return (
    <ModalConfirm
      open={open}
      onClose={onCancel}
      title={
        <FormattedMessage {...messages.completeCertificationsModalTitle} />
      }
      TitleProps={{
        sx: (theme) => ({
          ...theme.typography.titleLarge,
        }),
      }}
      actionsProps={[
        {
          children: <FormattedMessage {...confirmMessages.cancel} />,
          onClick: onCancel,
          variant: 'text',
        },
        {
          children: <FormattedMessage {...confirmMessages.confirm} />,
          onClick: onConfirm,
          submitButton: true,
          isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      ContentProps={{
        sx: {
          maxWidth: 565,
        },
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="bodyMedium" color={lightGrey.dark} display="block">
          <FormattedMessage
            {...messages.completeCertificationsModalBodyIntro}
            values={{ effectiveDate }}
          />
        </Typography>
        <Typography variant="bodyMedium" color={lightGrey.dark} display="block">
          <FormattedMessage
            {...messages.completeCertificationsModalBodyPrompt}
          />
        </Typography>
        <Banner
          status="info"
          message={
            <FormattedMessage
              {...messages.completeCertificationsLockInfoBanner}
            />
          }
        />
        {hasMissingRequiredData ? (
          <Banner
            status="warning"
            message={
              <FormattedMessage
                {...messages.completeCertificationsMissingDataWarningBanner}
              />
            }
          />
        ) : null}
      </Stack>
    </ModalConfirm>
  );
};

export default CompleteCertificationsModal;
